var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "intl-news" },
    [
      _c("IntlBreadcrumb"),
      _vm._v(" "),
      _c("div", { staticClass: "intl-news__head" }, [
        _c("h1", { staticClass: "intl-news__title" }, [
          _vm._v(_vm._s(_vm.$t("news.pageTitle"))),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "intl-news__desc" }, [
          _vm._v(_vm._s(_vm.$t("news.pageDesc"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "intl-news__toolbar" },
        [
          _vm.newsCats.length
            ? _c("CategoryFilter", {
                attrs: { categories: _vm.newsCats, active: _vm.activeCat },
                on: { change: _vm.onCatChange },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "intl-news__search" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keyword,
                  expression: "keyword",
                },
              ],
              attrs: { placeholder: _vm.$t("common.searchNews") },
              domProps: { value: _vm.keyword },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onSearch($event)
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.keyword = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("button", { on: { click: _vm.onSearch } }, [_vm._v("🔍")]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.newsList.length
        ? _c(
            "div",
            { staticClass: "intl-news__list" },
            _vm._l(_vm.newsList, function (item) {
              return _c("NewsCard", {
                key: item.id,
                attrs: { news: item },
                on: { click: _vm.goDetail },
              })
            }),
            1
          )
        : _c("div", { staticClass: "intl-news__empty" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("common.noNews")) + "\n  "),
          ]),
      _vm._v(" "),
      _c("IntlPagination", {
        staticClass: "intl-news__pager",
        attrs: { page: _vm.pageNum, size: _vm.pageSize, total: _vm.total },
        on: { change: _vm.changePagination },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }